const emptySymbol = '-';

export { emptySymbol };
